const defaults = {
  /**
   * Brand Name
   */

  brandName: "Partner Portal",
  poweredBy: "CloudCard",

  // Labels

  /**
   * Login
   */

  signInLabel: "Sign in",
  welcomeLabel: "Welcome",
  signInAccoutText: "Sign in to your account",
  loginTitle: "Partner Portal",
  loginDescription: "Omni channel Business payments",
  loginButtonLabel: "Login",
  cardOrderTitle: "New Accounts",
  twoFACodeVerificationTitle: "Enter Verification Code",
  twoFADescription: "Open your authenticator app and enter the code for partner portal",
  twoFaEmailDescription: "Enter the 6 digit passcode sent at your registered email",
  twoFaPhoneDescription: "Enter the 6 digit passcode sent at your registered phone number",
  rememberMeText: "Remember me",

  twoFATitle: "Two-factor Authentication",
  verifyLabel: "Verify",
  CloudCardLogoLabel: "CloudCardLogo",
  cardsTitle: "Cards",
  noCardDescription: "No Cards Yet",
  noAccountDescription: "No Accounts Yet",
  noFundAccountDescription: "No Account Found",
  noCardholdersLabel: "No Cardholders Yet",
  uploadCSVTitile: "Upload CSV File",
  uploadCSVDescription: "Please upload formatted CSV file. You can download sample file below.",
  uploadCSVLabel: "Select and upload",
  downloadCSVLabel: "Download CSV Sample File",
  downloadExcelLabel: "Download Excel Sample File",
  provideShipmentLabel: "Provide Shipping Details",
  noteInputRequiredError: "Notes value is required",

  enableTwoFADescription: "Please enable two-factor authentication on your account",
  enableLabel: "Enable",

  useAuthenticatorLabel: "Use Authenticator App",
  oneTimeSetupLabel: "One-time setup",

  enabledSuccessfulLabel: "Enabled Successfully!",
  twoFASuccessfulEnableDescription: "Two-factor authentication has been enabled successfully",

  ddaLabel: "DDA",
  availableBalanceLabel: "Available Balance",
  routingLabel: "Routing Number",

  emailAddressLabel: "Email Address",
  passwordLabel: "Password",

  forgotPasswordTitle: "Forgot Password",
  forgotPasswordDescription: "Please enter your email to reset password",

  resetPasswordLabel: "Reset Password",
  setPasswordTitle: "Set New Password",
  orderDetailTitle: "Order Details",
  cardsDetailsTitle: "Review Batch",
  batchInformationTitle: "Batch Information",
  setPasswordDescription: "To complete forgot password process, please set password",
  retypePasswordLabel: "Re-type Password",
  newPasswordLabel: "New Password",
  retypeNewPasswordLabel: "Re-type New Password",

  resendText: "Resend Code",

  passwordResetSuccessfulLabel: "Reset Successfully!",
  passwordResetSuccessfulDescription: "Password has been reset successfully",
  backToLoginLabel: "Back to login",

  dashboardTitle: "Dashboard",
  homeTitle: "Home",
  cardOrdersTitle: "New Card Accounts",
  consumersTitle: "Consumers",
  usersTitle: "Users",
  sellCardsTitle: "Card Sale",
  registerCardsTitle: "Reports",
  loadFundsTitle: "Load Funds",
  NewCardRegisterTitle: "Card Registration",
  supportTitle: "Support",
  myConsumersTitle: "Consumers",
  userManagementTitle: "User Management",
  reviewKycTitle: "KYC Review",
  debitFundsTitle: "Debit Funds",
  employmentCategoryLabel: "Employment Category",
  employmentCategoryOptionalLabel: "Employment Category (Optional)",

  NewCardSaleTitle: "Sell a card",
  NewCardSaleDescription: "Provide details in order to sell card",

  cardProxyTitle: "Proxy No*",
  cardProxyDescription: "Enter the proxy no manually or scan with reader.",

  amountTitle: "Load Funds",
  amountDescription: "Enter the amount to load funds into the card and select payment method.",

  newUserLabel: "New User",
  newUserFormHeadingLabel: "New User",
  userInformationHeadingLabel: "User Information",
  userFormFirstNameLabel: "First Name",
  userFormLastNameLabel: "Last Name",
  userFormEmailLabel: "Email",
  userFormMobileLabel: "Mobile",
  userFormCancelLabel: "Cancel",
  userFormSaveLabel: "Create",
  userFormUpdateLabel: "Update",
  activeUserLabel: "Active",
  InactiveUserLabel: "Inactive",
  editUserLabel: "Edit User",
  switchEmployerLabel: "Switch Employer",
  sendInviteLabel: "Send Invite",
  blockUserActionLabel: "Block User",
  activateUserActionLabel: "Activate User",
  sendInviteSuccess: "Invitation has been sent.",
  userStatusUpdateSuccess: "User status has been updated successfully.",
  userCreationSuccess: "New user has been created successfully.",
  userFormAffiliateFieldLabel: "Employer *",
  userFormMultiAffiliateFieldLabel: "Select Employers *",
  userFilterAffiliateFieldLabel: "Select Employer",

  employersTitle: "Employers",
  employerInformationLabel: "Information",
  controlPersonTitle: "Control Person",
  documentsTitle: "Documents",
  documentsTabTitle: "KYC & Documents",
  reviewTabTitle: "Review & Actions",
  reviewNotesTitle: "Review Notes",
  accountsCardsTitle: "Accounts & Cards",
  documentTypeSelectLabel: "Document Type",
  addFileLabel: "Add File",
  chooseFileLabel: "Choose File",
  maxFileSizeText: "Max file size 5MB",
  kycMaxFileSizeText: "Max file size 5MB",
  uploadFileSuccess: "Document uploaded successfully.",
  uploadFileFailure: "Error occurred while uploading document.",
  notesTitle: "Notes",
  notesHistoryTitle: "History",
  employersDescription: "Manage your onboarded Affiliates",
  addNewAffiliate: "Add New",
  employerScreenTitle: "Employers",
  employerDetailScreenTitle: "Details",
  employerAddNewScreenTitle: "Add New Employer",
  employersGridIdLabel: "Employer ID",
  employersGridCompanyNameLabel: "Company Name",
  employersGridNameLabel: "name",
  employersGridEmailLabel: "Business Email",
  employersGridEnrollmentDateLabel: "Enrollment Date",
  employersGridStatusLabel: "Status",
  employersDetailHeading: "Employer ID",

  sessionTimeoutTitleLabel: "Session Expiry Alert!",
  sessionTimeoutDescriptionLabel: "Your session is about to expire. You will be logged out shortly",

  orderCardDescription: "Enroll new consumers and Create bulk card accounts",
  loadFundsDescription: "Initiate Payroll and Card Loads",
  myConsumersDescription: "Consumer List with Card Account details",
  userManagementDescription: "Create and Manage Users",
  NewCardRegisterDescription: "Here you can register single card or bulk card(s) and see status",
  sellCardsDescription: "Sell a card using the preprinted inventory",
  registerCardsDescription: "See the detail and summary level reports",
  kycReviewDescription: "Processing OFAC and KYC Failures",
  debitFundsDescription: "Initiate a debit on an account",

  kycReviewGridNameLabel: "Name",
  kycReviewGridDateLabel: "Creation Date",
  kycReviewGridEmailLabel: "Email",
  kycReviewGridPartnerLabel: "Partner",
  kycReviewGridEmployerLabel: "Employer",
  kycReviewGridOfacStatusLabel: "OFAC Status",

  accountNumberTitle: "Account Number",
  accountDetailsTitle: "Account Details",
  availableBalanceTitle: "Available Balance",
  currencyTitle: "Currency",

  welcomeToPortalLabel: "Welcome!",
  dashboardChooseOptionLabel: "Please choose an operation from the list below",

  orderCardsTitle: "Create Order",
  orderCardsDescription:
    "Standard corporate cards with optional daily, weekly, or monthly spend limit. This is typically used for daily corporate expenses where receipts may be required.",

  loadFundTitle: "Load Fund(s)",
  loadFundDescription: "Follow the steps and load funds",

  loadFundsGridIdLabel: "ID",
  loadFundsGridDateLabel: "Creation Date",
  loadFundsGridEmployerLabel: "Employer",
  loadFundsGridStatusLabel: "Status",
  loadFundsGridTotalLabel: "Total",
  loadFundsGridGeneratedLabel: "Generated",
  loadFundsGridFailedLabel: "Failed",
  loadFundsGridAmountProcessedLabel: "Total Amount Processed",

  loadFundsDetailDateLabel: "Date",
  loadFundsDetailAmountLabel: "Amount",
  loadFundsDetailCurrencyLabel: "Currency",
  loadFundsDetailPartnerLabel: "Partner",
  loadFundsDetailEmployerLabel: "Employer",

  cancelLabel: "Cancel",
  nextLabel: "Next",
  previousLabel: "Previous",
  backLabel: "Back",
  submitLabel: "Submit",
  saveLabel: "Save",

  orderCardBasicDetailTitle: "Lorem Ispum",
  orderCardBasicDetailDescription:
    "Lorem Ispum is simply dummy text of the printing and typesetting industry.",

  loadFundBasicDetailTitle: "Lorem Ispum",
  loadFundBasicDetailDescription:
    "Lorem Ispum is simply dummy text of the printing and typesetting industry.",

  selectPartnerLabel: "Select Partner",
  selectAffiliateLabel: "Select Employer",
  selectProductLabel: "Select Product",

  numberOfCardsLabel: "Number of Cards",
  nameOnCardLabel: "Name on Card",
  extraEmbrossingLineLabel: "Extra Embossing Line 4",

  nameOnCardDefaultValue: "Valued Customer",

  currencyLabel: "Currency",

  amountLabel: "Amount",
  loadingEventLabel: "Load funds at the time of",

  firstNameLabel: "First Name",
  middleNameLabel: "Middle Name",
  lastNameLabel: "Last Name",
  emailLabel: "Email",
  phoneLabel: "Phone",
  dateOfBirthLabel: "Date of Birth",
  identificationTypeLabel: "Identification Type",
  identificationNumberLabel: "Identification Number",
  genderLabel: "Gender",
  externalReferenceNumberLabel: "Ext Ref No",
  ssnLabel: "SSN",
  passportLabel: "Passport",
  driverLicenseLabel: "Driver's Licence",
  locationLabel: "Location",
  personalizedNameOnCardLabel: "Name on Card",
  identityTypeLabel: "Identity Type",
  identityNumberLabel: "Identity Number",
  externalRefNoLabel: "External Ref No",
  externalRefNumberLabel: "External Ref Number",
  partnerNameLabel: "Partner Name",
  employerNameLabel: "Employer Name",

  physicalAddressLabel: "Physical Address",
  addressLabel: "Address",
  line2Label: "Line 2",
  cityLabel: "City",
  countryLabel: "Country",
  stateLabel: "State",
  postalCodeLabel: "Postal Code",
  zipOrPostalCodeLabel: "Zip or Postal Code",

  profileInformationTitle: "Profile Information",
  billingAddressInformationTitle: "Billing Address Information",
  billingAddressLabel: "Billing Address",
  shippingInformationTitle: "Shipping Address Information",
  INVALID_LICENSE: "Invalid Driver's License Number!",
  INVALID_PASSPORT: "Invalid Passport Number!",
  MIN_AGE_LIMIT: "Minimum age limit is 18 years old",
  pointOfContactLabel: "Point of Contact",
  nameLabel: "Name",
  INVALID_AGE_RANGE: "Age should be between {MIN} and {MAX} years",

  newAccountsMinAge: "18",
  newAccountsMaxAge: "70",

  yesLabel: "Yes",
  noLabel: "No",
  statusChangeFailureDescription: "Card Status Cannot be Changed",
  initialLoadLabel: "Initial Load Details",

  cardIdLabel: "Card ID",
  accountIdLabel: "Account ID",
  descriptionLabel: "Description",

  confirmLabel: "Confirm",

  phoneNumberLabel: "Phone no",

  detailsLabel: "Details",
  detailsDescription: "Read only details from previous step",
  salesRepresentativeLabel: "Sales Representative",
  reviewDetailsLabel: "Review Details",
  reviewDetailsDescription: "If you want to change anything you can jump from above steps",

  orderDetailsLabel: "Order Details",
  shippingDetailsLabel: "Shipping Details",

  legalNameLabel: "Legal Name",
  createdStartDateLabel: "Created Start Date",
  createdEndDateLabel: "Created End Date",
  approvedStartDateLabel: "Approved Start Date",
  approvedEndDateLabel: "Approved End Date",

  personalizedLabel: "Personalized",
  instantIssueCardLabel: "Instant Issue Cards",
  partnerLabel: "Partner",
  affiliateLabel: "Employer",
  productNameLabel: "Product Name",
  productDetailsLabel: "Product Details",
  orderTypeLabel: "Batch Type",
  cardEntryTypeLabel: "Card Entry Type",
  cardListLabel: "Card List",
  fileNameLabel: "File Name",
  totalCardsLabel: "Total Cards",
  totalAccountsLabel: "Total Accounts",
  accountsEntryTypeLabel: "Account Entry Type",
  pocNameLabel: "Name",
  shippingAddressLabel: "Shipping Address",
  shippingMethodLabel: "Shipping Method",
  mailingAdressLabel: "Mailing Address",
  cardOrdersDetailTitle: "Batch Details",
  orderDetailDescription: "You can see the complete order details below",
  orderIDLabel: "Order ID:",
  addCardTitle: "Add Accounts",
  cardDetailsDescription: "Enter the details to add an account",
  updateCardDetailsDescription: "Enter the details to update a card",
  addFundsDescription: "Enter the details to add fund",
  updateFundsDescription: "Enter the details to update fund",
  closeButtonLabel: "Close",
  resetButtonLabel: "Reset",
  addButtonLabel: "Add",
  updateButtonLabel: "Update",
  stayButtonLabel: "Stay",
  logoutButtonLabel: "Logout",

  updateFundLabel: "Update Fund",
  addFundLabel: "Add fund",
  addFundsLabel: "Add Funds",
  addRecordsLabel: "Add Records",
  dabitFundLabel: "Debit Fund",

  updateCardTitle: "Update Card",

  newCardDateTimeLabel: "Date & Time",
  newCardPartnerLabel: "Partner",
  newCardEmployerLabel: "Employer",
  newCardProductNameLabel: "Product Name",
  newCardBatchTypeLabel: "Batch Type",
  newCardUserIdLabel: "User ID",
  newCardTotalRecordsLabel: "Total Records",
  newCardGeneratedLabel: "Generated",
  newCardFailedLabel: "Failed",
  newCardCurrencyLabel: "Currency",
  newCardNameOnCardLabel: "Name On Card",
  newCardAmountLabel: "Amount",
  newCardGridBatchIdLabel: "Batch ID",
  newCardGridBatchDateLabel: "Batch Date",
  newCardGridEmployerLabel: "Employer",
  newCardGridUserIdLabel: "User ID",
  newCardGridStatusLabel: "Status",
  newCardGridTotalRecordsLabel: "Total",
  newCardGridGeneratedLabel: "Generated",
  newCardGridFailedLabel: "Failed",

  orderLabel: "Order",
  cardOrderSuccessMessage: "Card(s) ordered successfully",
  applyFilterText: "Apply",
  mandatoryFilterError: "Select at least one filter",
  newAccountDateTimeLabel: "Date & Time",
  newAccountPartnerLabel: "Partner Name",
  newAccountEmployerLabel: "Employer",
  newAccountProductNameLabel: "Product Name",
  newAccountBatchTypeLabel: "Batch Type",
  newAccountUserIdLabel: "User ID",
  newAccountTotalRecordsLabel: "Total Records",
  newAccountGeneratedLabel: "Generated",
  newAccountFailedLabel: "Failed",
  newAccountUnderReviewLabel: "Under Review",
  newAccountGridBatchIdLabel: "Batch ID",
  newAccountGridBatchDateLabel: "Batch Date",
  newAccountGridEmployerLabel: "Employer",
  newAccountGridUserIdLabel: "User ID",
  newAccountGridStatusLabel: "Status",
  newAccountGridTotalRecordsLabel: "Total",
  newAccountGridGeneratedLabel: "Generated",
  newAccountGridFailedLabel: "Failed",
  newAccountGridUnderReviewLabel: "Under Review",
  newAccountPocNameLabel: "Name",
  newAccountPhoneLabel: "Phone",
  newAccountShipmentMethodHeading: "Shipment Method",
  newAccountAddressLabel: "Address",
  newAccountDirectShipToEmployeeHeading: "Direct shipment to employee",
  newAccountDirectShipToEmployeeLabel:
    "All cards will be shipped to employees at the addresses specified in their respective records.",

  fundDetailsLabel: "Review Batch",
  fundEntryTypeLabel: "Fund Entry Type",
  totalFundsLabel: "Total Funds",
  confirmFundSuccessMessage: "Batch has been logged successfully",
  cardStatusSuccessMessage: "Card status has been changed successfully",

  filterButtonLabel: "Filter",
  totalRecordsLabel: "Total Records",
  fileUploadSuccessMessage: "File Uploaded Successfully",
  findDetailsLabel: "Find the file details below",
  generatedLabel: "Generated",
  failedLabel: "Failed",
  uploadFileNameLabel: "Filename",
  uploadFileName: "Uploaded File",
  emptyFileName: "Uploaded file is empty.",
  readOnlyDescription: "Read only grid view of uploaded file",

  recordsTitle: "Records",

  confirmationMessage: "Are You Sure?",
  orderConfirmationText: "Are you sure you want to create this order?",
  loadFundsConfirmText: "Are you sure you want to load funds?",
  cardStatusChangeLabel: "You want to cardStatus this card.",
  confirmationCancelOrderDescription: "This will discard all changes.",
  confirmationCancelOrderDiscardDescription: "If you cancel all detail will discard",
  confirmationCancelLoadFundDescription: "This will discard all changes",
  confirmationCancelDebitFundDescription: "This will discard all changes",
  confirmationRequestDocumentDescription: "You want to Request Document",
  confirmationStepChangeDescription: "This will discard all changes",
  confirmationStepChangeFileDescription:
    "Your file will be discarded if you switch to Manual Entry",
  confirmationStepChangeManualDescription:
    "Your input data will be discarded if you switch to File Upload",

  cardholderListTitle: "Cardholders List",
  cardholderListDescription: "You can see all the cardholders below",
  cardholderTitleLabel: "Cardholder Detail",
  billingAddressTitleLabel: "Billing",
  shippingAddressTitleLabel: "Shipping",
  cardholderDescriptionLabel: "Cardholder complete detail",

  cardsListTitle: "Cards List",
  cardsListDescription: "You can see all the cards below",

  newOrderLabel: "New",
  noOrderExistLabel: "No order exists",
  noConsumerExistLabel: "No consumer exists",
  noEmployerExistLabel: "No employer exists",
  noKycReviewerExistLabel: "No reviewer exists",
  noTransactionLabel: "No Transactions Yet",
  noFundsLoadLabel: "No Record Found",
  noUserExistLabel: "No user exists",
  transactionsTitle: "Transactions",
  transactionsTabTitle: "Transactions",
  logoutLabel: "Logout",
  noAffiliateTransactionsLabel: "No Employer Transactions",

  fromDateLabel: "From Date",
  toDateLabel: "To Date",

  selectFundsLabel: "Select Fund Type",
  selectOrderLabel: "Select Batch Type",
  addCardLabel: "Add Accounts",
  addAccountButtonLabel: "Add Account",
  shipmentLabel: "Shipment Detail",
  reviewLabel: "Review & Confirm",

  selectEmployerLabel: "Select Employer",
  addRecordLabel: "Add Record",
  reviewAndConfirmLabel: "Review & Confirmation",
  fundsReviewBatchLabel: "Review Batch",
  debitFundsConfirmationText: "You want to debit funds",
  yesIamSureLabel: "Yes, I am Sure",
  debitFundsSuccessMessage: "Batch has been logged successfully.",
  debitBatchDescriptionPrefix: "Debit Transaction",

  debitFundsPreviewPartnerLabel: "Partner",
  debitFundsPreviewEmployerLabel: "Employer",
  debitFundsPreviewDdaLabel: "DDA",
  debitFundsPreviewCardIdLabel: "Card ID",
  debitFundsPreviewAccIdLabel: "Account ID",
  debitFundsPreviewBalanceLabel: "Available Balance",
  debitFundsPreviewAmountLabel: "Debit Amount",
  debitFundsTransactionsLabel: "Transactions",
  debitFundsReviewActionsLabel: "Review & Actions",
  debitFundsDetailInfoLabel: "Information",

  noFundsDebitLabel: "No Record Found",
  debitFundsGridIdLabel: "ID",
  debitFundsGridDateLabel: "Creation Date",
  debitFundsGridEmployerLabel: "Employer",
  debitFundsGridStatusLabel: "Status",
  debitFundsGridTotalLabel: "Total",
  debitFundsGridGeneratedLabel: "Generated",
  debitFundsGridFailedLabel: "Failed",
  debitFundsGridAmountProcessedLabel: "Total Amount Processed",

  loadFundsLabel: "Load Funds",
  manualEntryLabel: "Manual Entry",
  fileUploadLabel: "File Upload",
  loadFundCsvFileLink: "https://cc-widgets-assets.s3.amazonaws.com/load-funds-sample-file.csv",
  orderCardCsvFileLink: "https://cc-widgets-assets.s3.amazonaws.com/card-orders-sample.csv",
  loadFundExcelFileLink:
    "https://portal-static-images.cloudcardapp.com/load-funds-excel-sample.xlsx",
  orderCardExcelFileLink:
    "https://portal-static-images.cloudcardapp.com/card-order-excel-sample.xlsx",
  orderCardFileName: "Partner-Portal-Personalized-Order",
  addMoreLabel: "Add Accounts",

  cardShipmentTitle: "Card Shipment",
  selectShipmentLabel: "Select the shipping address",
  otherShipmentLabel: "Ship to a different address",

  anyofIdLabel: "Any of the Card ID, Account ID or DDA is required",
  noAccountError: "No funding account is attached!",
  noBusinessProfileError: "No business profile is attached!",

  forgotPasswordPinFormTitle: "Check your email",
  forgotPasswordPinFormDescription: "An OTP has been sent to",
  forgotPasswordPinFormDescriptionTwo: "Please enter the code.",
  continueLabel: "Continue",

  confirmationModalTitle: "Are You Sure?",
  confirmReviewActionText: "You want to change request status to ",
  closeEmployerActionText:
    "If you close this employer it cannot be undone and all the \naccounts of the employer will be locked",
  confirmationLogoutDescription: "You want to Logout",
  confirmeviewContinueButtonText: "Yes",
  confirmeviewCancelButtonText: "Cancel",
  confirmDiscardChanges: "Yes, I am Sure",
  kybApproved: "Approved",
  kybClosed: "Closed",
  kybApprovedSuccess: "Request has been approved.",
  kybStatusUpdateReason: "Updated employer status to {{status}}",
  affiliateStatusChangeSuccessMessage: "Employer Status changed to ",
  invitationLinkExpiry: "Invitation link has expired.",
  loginAgainError: "Your Session was expired. Please login Again!",
  gqlDefaultLoginError: "Please login to access this object",
  accessDeniedErrorLabel: "Your session is no longer valid or you do not have access.",
  mfaResetLinkExpiry: "MFA reset link has expired.",
  reissueFormCardProxyNoLabel: "Card Proxy Number",
  reissueFormReasonLabel: "Select Reason",
  reissueSuccessMessage: "Card reissued successfully",
  cancelReissue: "Cancel",
  submitReissue: "Submit",

  associateCardHeading: "Associate Card",
  associateCardTitle: "Provide Card Proxy Number",
  associateCardSubtitle:
    "Please enter the card proxy number for associating the card with this account.",
  associateCardFormCardProxyNoLabel: "Enter Number Here",
  associateCardSuccessMessage: "Card associated successfully",
  cancelAssociateCard: "Cancel",
  submitAssociateCard: "Submit",

  // styles

  activeGreenColor: "#1DD332",
  darkBlackColor: "#000000",
  blackColor: "#21252A",
  lightBlackColor: "#56575A",
  redTimerColor: "#FF8787",
  buttonBlueColor: "#3980F6",
  lightGreyColor: "#9EA0A5",
  previewGreyColor: "#7F8C8D",
  headerGreyColor: "#66788A",
  subTitleColor: "#A7A7A7",
  stepperLightGrayBackground: "#F9FAFB",
  borderBottomColor: "#E8EAEE",
  blueColor: "#0F3A5E",
  orderColor: "#758FC9",
  detailTitleColor: "#E4E4E4",
  detailSubtitleColor: "#1F1F1F",
  labelColor: "#A7A7A7",
  placeholderColor: "#00000099",
  textColor: "#000000",

  darkBlueColor: "#1341A2",
  whiteBackground: "#ffffff",
  fontColor: "#000000",
  grayColor: "#d8d8d8",
  stepGrayColor: "#BFBFBF",
  processColor: "#dD6FFBE",
  declineColor: "#FFBEBE",
  scheduledColor: "#dD6FFBE",
  printingColor: "#FFF2BE",

  primaryButtonLabelColor: "#fff",
  primaryButtonBackground: "#3981F7",
  processedStatus: "#D6FFBE",
  primaryButtonBorder: "#1665D8",

  secondaryButtonLabelColor: "#1665D8",
  secondaryButtonBackground: "#fff",
  secondaryButtonBorder: "#1665D8",
  boxBackgroundColor: "#fff",

  backgroundColor: "#FFFFFF",
  sidebarMenuColor: "#fff",
  dividerColor: "#E4E7EB",

  tableBorderColor: "#E4E7EB",
  tableCellBackgroundColor: "#F9FAFB",

  topBarTitleColor: "#0a2942",
  listBorderColor: "#BDC3C7",

  yellowColor: "#FFF2BE",
  greenColor: "#D6FFBE",
  redColor: "#FFBEBE",
  lightRedColor: "#FF4C4C",
  greyBlackColor: "#3A3B3F",
  tabsBlueColor: "#1665d8",
  tabsLightBlueColor: "#3980F6",
  lightSoftBlueColor: "#3980F6",

  blackTransparent: "rgba(0, 0, 0, 0.5)",

  // configs
  nameLength: 25,
  addressLength: 255,
  cityLength: 50,
  cardIdMaxLength: 16,
  accountIdMaxLength: 16,
  ddaMaxLength: 17,
  nameOnCardMaxLength: 26,
  support_menu: "N",
  userPhoneDefaultCountry: "us",
  userPhoneAvailableCountries: '["us"]',
  addAccountPhoneDefaultCountry: "us",
  addAccountPhoneAvailableCountries: "[]",
  consumerDefaultCountry: "US",
  consumerPhoneAvailableCountries: "[]",
  pocPhoneDefaultCountry: "us",
  pocPhoneAvailableCountries: "[]",
  employerSignupPhoneDefaultCountry: "US",
  employerSignupPhoneAvailableCountries: "",
  employerSignupControlPersonPhoneDefaultCountry: "US",
  employerSignupControlPersonPhoneAvailableCountries: "",
  employerSignupFirstUserPhoneDefaultCountry: "US",
  employerSignupFirstUserPhoneAvailableCountries: "",
  employerPhoneDefaultCountry: "US",
  employerPhoneAvailableCountries: "",
  controlPersonPhoneDefaultCountry: "US",
  controlPersonPhoneAvailableCountries: "",
  employerFirstUserPhoneDefaultCountry: "US",
  employerFirstUserPhoneAvailableCountries: "",
  updateEmployerBusinessPhoneDefaultCountry: "US",
  updateEmployerBusinessPhoneAvailableCountries: "",
  updateEmployerControlPersonPhoneDefaultCountry: "US",
  updateEmployerControlPersonAvailableCountries: "",
  countries: '[{"code":"USA","name":"United States of America"}]',
  states:
    '[{"code":"AL","name":"Alabama"},{"code":"AK","name":"Alaska"},{"code":"AZ","name":"Arizona"},{"code":"AR","name":"Arkansas"},{"code":"CA","name":"California"},{"code":"CO","name":"Colorado"},{"code":"CT","name":"Connecticut"},{"code":"DE","name":"Delaware"},{"code":"FL","name":"Florida"},{"code":"GA","name":"Georgia"},{"code":"HI","name":"Hawaii"},{"code":"ID","name":"Idaho"},{"code":"IL","name":"Illinois"},{"code":"IN","name":"Indiana"},{"code":"IA","name":"Iowa"},{"code":"KS","name":"Kansas"},{"code":"KY","name":"Kentucky"},{"code":"LA","name":"Louisiana"},{"code":"ME","name":"Maine"},{"code":"MD","name":"Maryland"},{"code":"MA","name":"Massachusetts"},{"code":"MI","name":"Michigan"},{"code":"MN","name":"Minnesota"},{"code":"MS","name":"Mississippi"},{"code":"MO","name":"Missouri"},{"code":"MT","name":"Montana"},{"code":"NE","name":"Nebraska"},{"code":"NV","name":"Nevada"},{"code":"NH","name":"New Hampshire"},{"code":"NJ","name":"New Jersey"},{"code":"NM","name":"New Mexico"},{"code":"NY","name":"New York"},{"code":"NC","name":"North Carolina"},{"code":"ND","name":"North Dakota"},{"code":"OH","name":"Ohio"},{"code":"OK","name":"Oklahoma"},{"code":"OR","name":"Oregon"},{"code":"PA","name":"Pennsylvania"},{"code":"RI","name":"Rhode Island"},{"code":"SC","name":"South Carolina"},{"code":"SD","name":"South Dakota"},{"code":"TN","name":"Tennessee"},{"code":"TX","name":"Texas"},{"code":"UT","name":"Utah"},{"code":"VT","name":"Vermont"},{"code":"VA","name":"Virginia"},{"code":"WA","name":"Washington"},{"code":"WV","name":"West Virginia"},{"code":"WI","name":"Wisconsin"},{"code":"WY","name":"Wyoming"}]',

  numberOfCardOptions: '[{"value":"1","name":"1"},{"value":"2","name":"2"}]',
  currencyOptions: '[{"value":"USD","name":"USD"}]',
  debitFundsCurrencyOptions: '[{"value":"USD","label":"USD"}]',
  debitFundsDefaultCurrency: "USD",
  requestedAmountExceedError: "Debit amount should be less than the available balance.",
  loadingEventOptions: '[{"value":"CREATION","name":"Creation"}]',
  brandFavicon: "brand-fav-icon.png",

  affiliateSortQueryParam: "last_name",

  // sidebarBackground: 'linear-gradient(139.26deg, #0647A6 0%, #442C96 100%)',
  sidebarBackground: "#D1F0FF",
  showFundingAccount: false,

  batchStatusOptions: `[{"name":"Confirmed","value":"C"},
  {"name":"Declined","value":"D"},
  {"name":"In Progress","value":"I"},
  {"name":"Incomplete","value":"N"},
  {"name":"Processed","value":"P"},
  {"name":"Resumed","value":"R"},
  {"name":"Scheduled","value":"S"},
  {"name":"Cancelled","value":"X"},
  {"name":"Failed","value":"F"}
]`,

  enrollmentStatusOptions: `[
  {"name":"Cancelled","value":"C"},
  {"name":"Declined","value":"D"},
  {"name":"In Progress","value":"I"},
  {"name":"Incomplete","value":"N"},
  {"name":"Processed","value":"P"},
  {"name":"Scheduled","value":"S"}
]`,

  kycApprovalOptions: `[
  {"name":"Approve","value":"APPROVED"},
  {"name":"Decline", "value":"DECLINED"}
]`,

  orderTypeOptions: `[{"name":"PERSONALIZED","value":"PERSONALIZED"},{"name":"NON_PERSONALIZED","value":"NON_PERSONALIZED"}]`,

  cardStatusOptions:
    '[{ "value": "NEW", "name": "New" },{ "value": "OPEN", "name": "Open" },{ "value": "FRAUD_BLOCKED", "name": "Fraud Block" },{"value": "BLOCKED", "name": "Block" },{ "value": "CLOSED", "name": "Close" }]',

  //Needs to be added in errors
  AU015: "Invalid Request: Provided Email has already been used.",
  AU022: "Invalid OTP: Retry Limit Exceeded",
  AU011: "Invalid OTP",
  SV001: "Invalid Request due to missing/wrong required parameters",
  SE001: "Please try again later",
  SE002: "Transaction timed out",
  SE003: "Resource not found",
  SE004: "Processing error",
  SE005: "Invalid or missing configurations",
  SE006: "System down",
  SE007: "System under maintenance (soft down)",

  GENERAL: "Something went wrong",
  REQUIRED: "Required!",
  INVALID_EMAIL: "Invalid Email!",
  INVALID_PHONE: "Invalid Phone Number!",
  INVALID_Name: "Invalid Name!",
  INVALID_RefNo: "Invalid External Reference number!",
  INVALID_POSTAL_CODE: "Invalid Postal Code!",
  INVALID_DATE: "Invalid Date!",
  INVALID_DATE_FORMAT: "Invalid Date Format",
  MINIMUM_POSTAL_CODE_LENGTH: "Minimum length should be 5",
  MAXIMUM_POSTAL_CODE_LENGTH: "Maximum length should be 15",
  INVALID_URL: "Invalid Website URL!",
  MISMATCH_PASSWORD: "Password do not match!",

  SHORT_PASSWORD: "Minimum 8 characters!",
  SHORT_SSN: "Minimum length should be 9",
  INVALID_SSN: "Invalid SSN!",
  INVALID_CITY: "Invalid City!",
  INVALID_CURRENCY_CODE: "Invalid Currency Code!",
  INVALID_POSTAL: "Invalid postal code!", //needs to be changed in db
  SHORT_POSTAL: "Minimum length should be 5",
  CARD_NUMBER_LIMIT: "Number of cards can be from 1 to 1500 only!",
  DESCRIPTION_MAX_LENGTH: "Description should be between 0 to 100 characters",
  INVALID_Number: "Should be numeric!",
  INVALID_AMOUNT: "Invalid Amount",
  ENTER_ONLY_ONE: "Enter only one of these!",
  ENTER_ONE_OF_THESE: "Enter one of these!",
  INVALID_FIRST_NAME: "Invalid first name",
  INVALID_MIDDLE_NAME: "Invalid middle name",
  INVALID_LAST_NAME: "Invalid last name",
  NO_DATA_FOUND: "No data found",
  PROVIDE_ONLY_ONE: "Please provide data only in one of the columns: Card ID, Account ID, or DDA",
  PROVIDE_AT_LEAST_ONE:
    "Please provide data in at least one of the columns: Card ID, Account ID or DDA",
  AMOUNT_REQUIRED: "Data in amount column is required",
  CURRENCY_REQUIRED: "Data in currency column is required",
  INVALID_TAX_ID_FORMAT: "Required format xx-xxxxxxx",
  INVALID_TAXID_LENGTH: "Minimum length should be 10",
  NAME_ON_CARD_INVALID_CHARS:
    "Use letters, numbers, spaces, commas, colons, slashes (/), hyphens (-), periods (.), apostrophes ('), or ampersands (&).",
  INVALID_DATE_RANGE: "From date cannot be greater than To date.",

  //side_bar menu options visibility Y(yes/true) N(no/false)
  card_orders: "Y",
  consumers: "Y",
  load_funds: "Y",
  sell_cards: "Y",
  register_cards: "N",
  employers: "Y",
  users: "Y",

  // Signup flow
  signupLabel: "Sign up",
  emailFormTitle: "Please provide a valid business email",
  emailFormSubTitle: "We will send you an OTP for the verification",
  otpCodeVerificationTitle: "Enter Verification Code",
  otpCodeVerificationSubtitle: "Enter 6 Digit OTP Code sent to your email",
  businessDetailTitleLabel: "Business Details",
  businessDetailSubtitle:
    "Please enter valid details of your company as we will use this information for the verification.",
  uploadDocumentsTitleLabel: "Upload Documents",
  reviewDetailsTitleLabel: "Review",
  successScreenTitle: "Your request has been submitted",
  successScreenSubtitle:
    "Please check email notifications for the next steps. Email at platform.support@cloudcardinc.com incase of any issue",
  looksGoodLabel: "Looks Good, Continue",
  doneLabel: "Done",
  businessDetailsLabel: "Business Details",
  uploadDocumentsLabel: "Upload Documents",
  reviewTextLabel: "Review",
  businessTabActiveIcon: "active-check-icon.png",
  businessTabInActiveIcon: "inactive-check-icon.png",
  businessTabFilledIcon: "filled-check-icon.png",
  companyInformationLabel: "Company Information",
  useAbovePersonFields: "Use the above information to create first admin user",
  uploadFileLabel: "Upload",
  iAgreeText: "I Agree to the",
  agreeTermsAndConditions: "Terms & Conditions",
  reviewContinueLabel: "Looks Good, Continue ",
  completingTitle: "Thank you for completing your application",
  completingNote:
    "It will take us a few minutes while we validate your company's details and set you up as a new entity in our system.",
  documentNotSupportedLabel: "Document type not supported",
  removeLabel: "remove",
  removeDocumentLabel: "Remove",
  maxFileSizeLength: 5,
  maxFileSizeContent: "Upload files with a total size of 5MB ",
  totalMaxFileSizeLength: 5,
  totalFileSizeContent: "Total file size cannot exceed 5MB",
  totalFileCountText: "You cannot upload more than 10 documents.",
  pleaseUploadFileText:
    "Please upload company documents for verification purposes e.g. Corporation documents, Article of Organization, Proof of address etc.",
  documentTypeVal: "ORG_DOC",
  documentTypeLabel: "Upload Documents",
  remainingText: "Remaining",
  documetSelectError: "Please Select Document Type",
  dateError: "Please select both From and To Date",
  maxDateError: "From date cannot be greater than To date",
  maxDurationError: `The duration exceeds the maximum allowed limit of {{days}} days`,
  downloadTransactionError: "An error occured while exporting transactions data",
  createKycEvaluationError: "Unable to create Kyc Evaluations",

  startDateRequiredError: "Start date is required if end date provided",
  createdStartDateRequiredError: "Created start date is required if created end date is provided",
  approvedStartDateRequiredError:
    "Approved start date is required if approved end date is provided",
  endDateRequiredError: "End date is required if start date provided",
  createdEndDateRequiredError: "Created end date is required if created start date is provided",
  approvedEndDateRequiredError: "Approved end date is required if approved start date is provided",
  startDateBeforeEndDateError: "Start Date should come before End Date",
  createdStartDateBeforeCreatedEndDateError:
    "Created Start Date should come before Created End Date",
  approvedStartDateBeforeApprovedEndDateError:
    "Approved Start Date should come before Approved End Date",

  fromDateRequiredError: "From Date is required if To Date provided",
  toDateRequiredError: "To Date is required if From Date provided",
  fromDateBeforeToDateError: "From Date should come before To Date",

  /**
   * Success Screen
   */

  submittedRequestText: "Your request has been submitted",
  pleaseCheckEmail:
    "Please check email notifications for the next steps. Email at platform.support@cloudcardinc.com incase of any issue",
  enrollmentSuccessImage: "enrollment-success-image.png",

  /**
   * AffiliateSetupSteps
   */

  setYourPasswordLabel: "Set your password",
  passwordPatternContentPartOne: "Password should be at least 8 characters long.",
  passwordPatternContentPartTwo:
    "Password must contain an uppercase letter, a lowercase letter, a number and a special character.",
  twoFALabel: "Two Factor Authentication",
  authCodeText: "Enter the authentication code",
  downloadAuthenticatorAppText:
    "<span class='first-of-all-text'>First of all</span> download & Install <a class='authentication-app-link' href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&pli=1'>Authenticator Application</a> onto your device to scan below QR code",
  secretCodeText: "If you can't scan this code copy below",
  twoFAEnabledLabel: "Two-Factor Authentication Enabled",
  affiliateSuccessText:
    "<span>All future logins will now require you to enter a code supplied by your authenticator app. You should now log in with your credentials and code to complete the enablement process.</span>",
  twoFAResetLabel: "Two-Factor Authentication Reset",
  affiliateResetSuccessText:
    "All future logins will now require you to enter a code supplied by your authenticator app. You should now log in with your credentials and code to complete the enablement process.",
  setTwoFALabel: "Two-Factor Authentication Enabled",
  setTwoFASuccessText:
    "All future logins will now require you to enter a code supplied by your authenticator app. You should now log in with your credentials and code to complete the enablement process.",

  step1Label: "Step 1",
  step2Label: "Step 2",
  scannedQRCodeText: "If you have scanned QR Code then click below",

  authTypeMfaSuccessTitle: "Two-Factor Authentication Enabled",
  authTypeMfaSuccessdescription:
    "All future logins will now require you to enter a code supplied by your authenticator app. You should now Login with your credentials and code to complete the enablement process.",
  authTypepasswordSuccessTitle: "Password Setup Successfull",
  authTypepasswordSuccessDescription: "Click here to Login.",
  authTypeEmailSuccessTitle: "Password Setup Successfull",
  authTypeEmailSuccessDescription: "Click here to Login",
  authTypeSmsSuccessTitle: "Password Setup Successfull",
  authTypeSmsSuccessDescription: "Click here to Login",
  passwordSetupLoginLabel: "Login",
  allowedAffiliateStatusesToGetUsers: "APPROVED,CLOSED",
  /**
   * Lost2FA
   */

  lostGAC: "Lost Your Authenticator Code?",
  emailSentLabel: "Email Sent",
  emailSentDescription:
    "Email is sent to registered email id with the instructions to reset your 2 factor authentication",
  gotoLoginLabel: "Back to Login",
  finishLabel: "Finish",
  copiedLabel: "Copied",

  /**
   * Add Employer
   */

  addEmployerBusinessDetailTitleLabel: "Business Details",
  addEmployerUploadDocumentsTitleLabel: "Upload Documents",
  addEmployerReviewDetailsTitleLabel: "Review",
  addEmployerBusinessDetailSubtitle:
    "Please enter valid details of your company as we will use this information for the verification.",
  addEmployerSuccessScreenTitle: "Your request has been submitted",
  addEmployerSuccessScreenSubtitle:
    "Please check email notifications for the next steps. Email at platform.support@cloudcardinc.com incase of any issue",
  addEmployerLooksGoodLabel: "Looks Good, Continue",
  addEmployerDoneLabel: "Done",
  addEmployerBusinessDetailsLabel: "Business Details",
  addEmployerUploadDocumentsLabel: "Upload Documents",
  addEmployerReviewTextLabel: "Review",
  addEmployerTabActiveIcon: "active-check-icon.png",
  addEmployerTabInActiveIcon: "inactive-check-icon.png",
  addEmployerTabFilledIcon: "filled-check-icon.png",
  addEmployerCompanyInformationLabel: "Company Information",
  addEmployerUseAbovePersonFields: "Use the above information to create first admin user",
  addEmployerUploadFileLabel: "Upload",
  addEmployerIAgreeText: "I Agree to the",
  addEmployerAgreeTermsAndConditions: "Terms & Conditions",
  addEmployerReviewContinueLabel: "Looks Good, Continue ",
  addEmployerCompletingTitle: "Thank you for completing your application",
  addEmployerCompletingNote:
    "It will take us a few minutes while we validate your company's details and set you up as a new entity in our system.",
  addEmployerDocumentNotSupportedLabel: "Document type not supported",
  addEmployerRemoveLabel: "remove",
  addEmployerMaxFileSizeLength: 5,
  addKycMaxFileSizeLength: 5,
  addEmployerMaxFileSize: "Max file size 5MB",
  kycMaxFileSize: "Upload: Max file size 10MB",
  addEmployerMaxFileSizeContent: "Upload files with a total size of 5MB ",
  addKycMaxFileSizeContent: "Upload files with a total size of 5MB ",
  addEmployerTotalFileSizeContent: "Total file size cannot exceed 5MB",
  addEmployerTotalFileCountText: "you cannot upload more than 10 documents.",
  addEmployerPleaseUploadFileText:
    "Upload company documents for verification purposes e.g. Corporation documents, Article of Organization, Proof of address etc.",
  addEmployerDocumentTypeVal: "ORG_DOC",
  addEmployerDocumentTypeLabel: "Organization Documents",
  addEmployerRemainingText: "Remaining",
  addEmployerSubmittedRequestText: "Your request has been submitted",
  addEmployerPleaseCheckEmail:
    "Please check email notifications for the next steps. Email at platform.support@cloudcardinc.com incase of any issue",
  addEmployerSuccessMessage: "Employer has been added successfully",
  updatedEmployerSuccessMessage: "Employer has been updated successfully",
  employerDocumentType: "Document Type",
  employerDocumentStatus: "Upload Status",
  employerDocumentAttachment: "Attachment(s)",
  employerMaxFileSize: "Max file size 5MB",
  employerMaxFileCountPerType: 3,
  employerMaxUploadLimit: "You have reached upload limit",

  /**
   *  Branding
   */

  verifyPasswordLabel: "Verify password",

  brandPrimaryColor: "#3981F7",

  loginBannerImgSrc: "login-banner-image.png",
  loginGradientBackgroundColor: "linear-gradient(120.37deg, #ffffff 2.71%, #d0effe 61.41%)",
  footerBrandLogo: "cloud-card-logo.png",

  hamburgerIconColor: "#000000",
  sideBarBackgroundColor: "#D1F0FF",
  sideBarExpandedBrandLogo: "cloud-card-logo.png",
  sideBarCollapsedBrandLogo: "collapsed-cc-logo.png",
  sideBarActiveMenuBackgroundColor: "",
  sideBarmenuItemTextColor: "#000000",
  sideBarActiveMenuItemTextColor: "#006CF8",
  sideBarIconColor: "#000000",
  sideBarActiveMenuColor: "#006CF8",

  homeCardBackground: "#FFFFFF",
  homeCardMenuBackground: "#FFFFFF",
  homeCardHoverMenuBackground: "#FFFFFF",
  homeCardHoverBackground: "#006CF8",
  homeCardImageContainerBackground: "#006CF8",
  homeCardImageContainerHoverBackground: "#FFFFFF",
  homeCardTitleColor: "#000000",
  homeCardTitleHoverColor: "#FFFFFF",
  homeCardDescriptionColor: "#00000080",
  homeCardDescriptionHoverColor: "#FFFFFF",
  homeCardIconColor: "#FFFFFF",
  homeCardIconHoveredColor: "#006CF8",

  buttonPrimaryBackgroundColor: "#006CF8",
  buttonPrimaryBorderColor: "#006CF8",
  buttonPrimaryTextColor: "#FFFFFF",
  buttonSecondaryBackgroundColor: "#FFFFFF",
  buttonSecondaryBorderColor: "#000000",
  buttonSecondaryTextColor: "#000000",

  blueColorLink: "#3980F6",

  linkTextColor: "#3980F6",

  detailsTabActiveBgColor: "#006CF8",
  detailsTabBgColor: "#ffffff",
  detailsTabTextColor: "#5F6368",
  detailsTabActiveTextColor: "#ffffff",

  // Footer
  copyrightText: "© {currentYear} Powered by CloudCard Inc.",
  copyRightText: "Copyright",
  incText: "Inc.",
  allRightsReserved: "All Rights Reserved",
  privacyLinkLabel: "Privacy Policy",
  termsAndConditionsLinkLabel: "Terms & Conditions",
  requestDocumentLabel: "Request Document",

  downloadConsumersCsvLabel: "Download CSV File",
  exportDataButtonLabel: "Export Data",
  exportFileButtonLabel: "Export File",
  selectFileHeading: "Select File",
  selectFileSubheading: "Please select the file and other associated details",
  selectFieldsHeading: "Select Fields",
  selectFieldsSubheading: "Select or unselect information to be included",
  consumerDetailsLabel: "Consumer Details",
  consumerGridIdLabel: "ID",
  consumerGridNameLabel: "Name",
  consumerGridEmailLabel: "Email",
  consumerGridPhoneLabel: "Phone",
  consumerGridPartnerLabel: "Partner",
  consumerGridEmployerLabel: "Employer",
  consumerGridCreatedOnLabel: "Created On",
  consumerGridKycStatusLabel: "KYC Status",
  depositFundsLabel: "Deposit Funds",
  transactionLabel: "Transactions",
  csvTemplate: "CONSUMERS_INTERMAX",
  downloadFileFormatsLabel: "Select file format",
  fromLabel: "From Date",
  toLabel: "To Date",
  fileScheduleSuccess:
    "Your request has been submitted. You will get notification once your file is ready for download.",
  selectAllOptionsLabel: "Select All",
  noMetaDashboardText: "Dashboard is not available.",
  dashboardLoadingText: "Loading Dashboard . . .",
  metabaseSwitcherButtonLabel: "Switch Dashboard",
  metabaseSwitcherLoadButtonLabel: "Load",
  metabaseSwitcherLoadedButtonLabel: "Load",
  metabaseSwitcherLastUpdatedLabel: "Last Updated:",
  metabaseSwitcherUnlistedDashboardLabel: "Dashboard",
  metabaseSwitcherTriggerBackgroundColor: "#000000",
  metabaseSwitcherTriggerTextColor: "#FFFFFF",
  metabaseSwitcherTriggerAccentIconColor: "#3980F6",
  metabaseSwitcherTriggerChevronColor: "#FFFFFF",
  metabaseSwitcherLoadButtonBackgroundColor: "#3980F6",
  metabaseSwitcherLoadButtonTextColor: "#FFFFFF",
  metabaseSwitcherLoadButtonActiveBackgroundColor: "#000000",
  metabaseSwitcherOptionHoverBorderColor: "#3980F6",
  metabaseSwitcherOptionActiveBorderColor: "#3980F6",
  reviewAndActionButtonText: "Review & Actions",
  ReviewAndActionsTitle: "Review & Actions",
  finalActionTitle: "Action",
  finalActionOptions: `[{"name": "Approve", "value": "CONFIRM"}, {"name": "Reject", "value": "CANCEL"}]`,
  confirmedLabel: "Confirmed",
  batchUpdateSuccessMessage: "Batch Updated Successfully",
  reviewFormErrorMessage: "Please enter Note and Action type",
  usersTabTitle: "Users",
  accountTabTitle: "Account",
  affiliateCompanyInformationLabel: "Company Information",
  statusHistoryTabTitle: "Status History",
  noStatusHistoryLabel: "No status history exists",
  editConsumerDetailLabel: "Edit Cardholder Details",
  editConsumerBillingAddressLabel: "Edit Billing Address",
  editConsumerShippingAddressLabel: "Edit Shipping Address",
  reviewConfirmationTitle: "Processing Confirmation?",
  reviewConfirmationApprovedMesssage: "Are you sure you want to approve the batch",
  reviewConfirmationRejectMesssage: "Are you sure you want to Reject the batch",
  reviewConfirmationButtonLabel: "Yes",
  totalAmountLabel: "Total Amount",
  updatedConsumerSuccessMessage: "Consumer information updated successfully",
  consumerTransactionsRequestTypes: `["TRANS_CREDIT", "DIRECT_CREDIT", "DIRECT_DEBIT"]`,
  kycReviewerTransactionRequestTypes: `["TRANS_CREDIT", "DIRECT_CREDIT", "DIRECT_DEBIT"]`,
  affiliateTransactionsRequestTypes: `[]`,
  consumerTransactionRequestTypes: "",
  downloadTransactionsRequestTypes: "",
  shippingInfoTitle: "Shipping Info",
  changeCardStatus: "Change Card Status",
  shippinginfoModalButtonLabel: "OK",
  loadFundsFileFields:
    "consumer.first_name,consumer.middle_name,consumer.last_name,account.dda_number,Trans Ext Reference No,account.billing_currency,Amount,Description",
  filtersHeading: "Filters",

  /**KYC REVIEWER */

  cardHolderIdLabel: "Cardholder ID:",
  createdOnLabel: "Created On:",
  kycStatuss: "KYC Status",
  updatedKycReviewerSuccessMessage: "KYC Reviewer information updated successfully",
  editKycReviewerDetailLabel: "Edit Cardholder Details",
  editKycReviewerShippingAddressLabel: "Edit Shipping Address",
  editKycReviewerBillingAddressLabel: "Edit Billing Address",
  downloadKycReviewersCsvLabel: "Download CSV File",

  // Consmer files listing & Downloading

  downloadSuccessMessage: "File Downloaded Successfully!",
  evaluationSuccessMessage: "Kyc Evaluation Created Successfully!",
  downloadErrorMessage: "Failed to Download File.",
  fileListingErrorMessage: "Unable to fetch Download File list.",

  /** Consumer  */

  kycWorkFlowLabel: "KYC Workflow",
  lastUpdatedAtLabel: "Last Updated On",
  statusLabel: "Status",
  reasonLabel: "Reason",
  noDocumentAvailableLabel: "No document available",
  notesLabel: "Notes",
  previewLabel: "Preview",
  historyLabel: "History",
  noHistoryNoteLabel: "No history available",
  uploadLabel: "Upload",
  noWorkFlowLabel: "No work flow available",
  kycStatusLabel: "KYC Status",
  uploadKycFlowDocumentSuccess:
    "Document uploaded successfully. Status may take some time to update.",
  informationLabel: "Information",
  detailLabel: "Detail",
  accountsAndCardsLabel: "Accounts & Cards",
  editInfoLabel: "Edit Info",
  editEmployerInfoLabel: "Edit Info",
  accountsLabel: "Accounts",
  currentBalanceLabel: "Current Balance",
  programNameLabel: "Program Name",
  noRecordFoundLabel: "No Record Found",
  reissueCardLabel: "Reissue Card",
  idLabel: "ID",
  dateLabel: "Date",
  cardLastFourLabel: "Card Last Four",
  transactionTypeLabel: "Transaction Type",
  responseLabel: "Response",
  pendingDocsLabel: "PENGIND DOC",
  timeSensitiveLabel: "Time Sensitive",

  // Role Metadata Starts

  pp_affiliates: `{"config_value": "Y", "title": "Employers"}`,
  pp_consumers: `{"config_value": "Y", "title": "Consumers"}`,
  pp_dashboard: `{"config_value": "Y", "title": "Dashboard"}`,
  pp_home: `{"config_value": "Y", "title": "Home"}`,
  pp_load_funds: `{"config_value": "Y", "title": "Load Funds"}`,
  pp_order_cards: `{"config_value": "Y", "title": "New Account"}`,
  pp_order_cards_non_personalized: `{"config_value": "Y", "title": "New Card Order"}`,
  pp_user_management: `{"config_value": "Y", "title": "User Management"}`,
  pp_kyc_review: `{"config_value": "Y", "title": "KYC"}`,
  pp_debit_funds: `{"config_value": "Y", "title": "Debit Funds"}`,

  addNewOrderBtn: "Y",
  addNewNonPersonalizedOrderBtn: "Y",
  exportBatchConsumersBtn: "Y",
  loadNewFundBtn: "Y",
  debitFundsNewBtn: "Y",
  exportConsumersBtn: "Y",
  exportEmployersBtn: "Y",
  exportTransactionsBtn: "Y",
  accountActions: "Y",
  cardActions: "Y",
  cardStatusChange: "Y",
  cardControls: "Y",
  addNewUserBtn: "Y",
  userActions: "Y",
  addNewAffiliateBtn: "Y",
  affiliateReviewAndActionsTab: "Y",
  showTransactionHistory: "Y",
  isBulkShipment: "Y",
  debitNewFundBtn: "Y",
  showCloseStatusAction: "N",

  // Role Metadata Ends

  showFundsSampleCsvFile: "Y",
  showFundsSampleExcelFile: "Y",

  showCardsSampleCsvFile: "Y",
  showCardsSampleExcelFile: "Y",

  showSignUpButton: "N",
  EmailAlreadyExistError: "Email providedEmail already taken",
  PhoneAlreadyExistError: "Phone number providedMobile already taken",
  emptyStatusFilterError: "Please select a status to apply filter",
  emptyUserFilterFieldsError: "Please provide value in filter(s)",
  showCardShippingInfo: "Y",
  consumerKycApproval: "N",
  cardOrderInstructionsTitle: "Batch File Instructions",
  cardOrderInstructions: `["Date of Birth format must be yyyy-mm-dd"]`,
  nonPersonalizedCardOrderTitle: "New Card Order",
  nonPersonalizesorderCardDescription: "Create bulk cards",
  kycStatusesForDocUpload: `["PENDING_DOCS"]`,
  userStatusFilterOptions: `[{"name": "Active", "code": true}, {"name": "In Active", "code": false}]`,
  personalizedBrandType: "PERSONALIZED",
  nonPersonalizedBrandType: "NON_PERSONALIZED",
  allowedFileTypesForBatch: ".csv, .xls, .xlsx",
  excelFileTypes: ".xls, .xlsx",
  wrongBatchFileTypeError: "Only CSV, XLS, XLSX type file can upload!",
  onlyExcelFileSupportedError: "Only XLS or XLSX type files are allowed",
  maxTransactionsDuration: "180",
  maxAffiliateTransactionsDuration: "180",
  maxDaysConsumerTransactions: "180",
  maxDaysAffiliateTransactions: "180",
  defaultDaysAffiliateTransactions: "180",
  defaultDaysConsumerDetailsTransactions: "180",
  defaultDaysEmployerDetailsTransactions: "180",
  consumerTransactionsTemplate: "TRANSACTIONS",
  affiliateTransactionsTemplate: "TRANSACTIONS",
  employersFileNamePrefix: "employers",
  employersTemplateCode: "EMPLOYERS",

  directToConsumerTextHeading: "Direct shipment to employee",
  directToConsumerTextDescription:
    "All cards will be shipped to employees at the addresses specified in their respective records.",

  fullViewDdaLabel: "View full DDA",
  hideLabel: "Hide",
  NALabel: "-",
  addCardsLabel: "Add Cards",

  reviewNoteLabel: "Review Note",
  internalIDLabel: "Internal ID",
  byLabel: "By",
  noReviewLabel: "No history available",
  noDataAvailable: "No data available",

  sendInvitationLabel: "Send Invitation",
  sendInvitationDescription: "Are you sure you want to send an Invite",
  updateUserInvitationDescription: "You want to update user status",

  rolesWithMultiSelectAffiliateField: "PP_PAYROLL_MANAGER,PP_PAYROLL_MANAGER_ADMIN",

  selectRoleLabel: "Select Role *",
  createNewLabel: "Create New",
  newAccountsLabel: "New Accounts",
  transactionsLabel: "Transactions",
  consumerLabel: "Consumer",
  dataLabel: "Data",
  kycLabel: "KYC",
  debitBatchRequestType: "TRANS_CREDIT",
} as any;

export default defaults;
